import { connect } from "react-redux";
import RateCar from "../components/Rate/Car";

const RateCarPage = ({ accessToken, currentLang }) => {
  return <RateCar accessToken={accessToken} currentLang={currentLang} />;
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(RateCarPage);
